import { render, staticRenderFns } from "./DrivingLessonTaskGroups.vue?vue&type=template&id=4af870c8&scoped=true"
import script from "./DrivingLessonTaskGroups.vue?vue&type=script&lang=ts"
export * from "./DrivingLessonTaskGroups.vue?vue&type=script&lang=ts"
import style0 from "./DrivingLessonTaskGroups.vue?vue&type=style&index=0&id=4af870c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af870c8",
  null
  
)

export default component.exports